export default __webpack_public_path__ + "static/media/blogIndex2.b1910ec2.png";